export const SLUG_LS = "slug"
export const LAST_SUCCESS_TIME_LOG_IN = "__lst-ks"
export const LAST_SUCCESS_SLUG_LOG_IN = "__lss-ks"
// Set while signed in through Kodem, by SSO or password (no Firebase user; the session lives in the
// API cookies)
export const KODEM_SESSION_LS = "__kss-ks"
// Session storage mark of a Kodem SSO popup, copied into it from the sign-in page that opens it
export const KODEM_SSO_POPUP_SS = "__ksp-ks"

export const X_SCOPE_ID = "X-Scope-Id"
export const X_SCOPE_NAME = "X-Scope-Name"

export const SPLASH_SCREEN_ON_BOARDING = "splashScreenOnBoarding"

export const LANGUAGE_LS = "lng-ks"
